import { render, staticRenderFns } from "./index.vue?vue&type=template&id=69574224&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeCarousel: require('/var/web/bet777.es/components/home/carousel.vue').default,SuperbannerBetbuilder: require('/var/web/bet777.es/components/superbanner/betbuilder.vue').default,UiTabButton: require('/var/web/bet777.es/themes/dark/ui/Tab/Button.vue').default,UiTabHorizontal: require('/var/web/bet777.es/themes/dark/ui/Tab/Horizontal.vue').default,UiSportTab: require('/var/web/bet777.es/themes/dark/ui/Sport/Tab.vue').default,UiSportTabs: require('/var/web/bet777.es/themes/dark/ui/Sport/Tabs.vue').default,EventsWidget: require('/var/web/bet777.es/components/events/widget.vue').default})
